class Carousel extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.breakpoint = 1024;
    this.lastIsMobile = null;

    this.handleResize = this.onResize.bind(this);
  }

  connectedCallback() {
    // DOM references moved here for safety
    this.container = this.querySelector('[data-swiper-el]');
    this.wrapper = this.querySelector('[data-swiper-wrapper]');
    this.slides = this.querySelectorAll('[data-swiper-slide]');
    this.prevEl = this.querySelector('[data-swiper-prev]');
    this.nextEl = this.querySelector('[data-swiper-next]');

    this.setDimensions();
    this.toggleSwiper(true); // force initial evaluation
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    this.destroySwiper();
  }

  toggleSwiper(force = false) {
    // Always run setDimensions to apply dynamic sizing
    this.setDimensions();

    // Initialize Swiper if not already active
    if (!this.swiperInstance) {
      this.addSwiperClasses();
      this.initSwiper();
    } else {
      // Swiper already exists — just update dimensions
      this.swiperInstance.update();
    }
  }

  addSwiperClasses() {
    this.container.classList.add('swiper');
    this.wrapper.classList.add('swiper-wrapper');
    this.slides.forEach((slide) => slide.classList.add('swiper-slide'));
  }

  removeSwiperClasses() {
    this.container.classList.remove('swiper');
    this.wrapper.classList.remove('swiper-wrapper');
    this.slides.forEach((slide) => slide.classList.remove('swiper-slide'));
  }

  setDimensions() {
    let slideWidth;
    let slideHeight;

    if (window.innerWidth < 1024) {
      slideWidth = window.innerWidth * 0.9;
      slideHeight = window.innerWidth * 1.25;
    } else {
      slideHeight =
        window.innerWidth * 0.5 <= window.innerWidth * 0.9 ? window.innerWidth * 0.5 : window.innerWidth * 0.9;
      slideWidth = slideHeight * 0.8;
    }

    this.slides.forEach((slide) => {
      slide.style.width = `${slideWidth}px`;
      slide.style.height = `${slideHeight}px`;
    });

    if (this.swiperInstance) {
      this.swiperInstance.update();
    }
  }

  initSwiper() {
    this.swiperInstance = new window.Swiper(this.container, {
      modules: [window.SwiperModules.Navigation, window.SwiperModules.Autoplay],
      slidesPerView: 'auto',
      spaceBetween: 2,
      loop: true,
      speed: 600,
      navigation: {
        prevEl: this.prevEl,
        nextEl: this.nextEl,
      },
      grabCursor: false,
      autoplay: {
        disableOnInteraction: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  onResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => this.toggleSwiper(), 200);
  }
}

customElements.define('auto-carousel', Carousel);
